export const runningTradeConfig: Record<
  RunningTradeKey,
  { limit: number; speed: number }
> = {
  widget: {
    limit: 100,
    speed: 100, // means 100 item/s
  },
  fastOrder: {
    limit: 100,
    speed: 100, // means 100 item/s
  },
  company: {
    limit: 10,
    speed: 100,
  },
};

export const runningTradeAction: Record<RunningTradeStockAction, string> = {
  0: '',
  1: 'Buy',
  2: 'Sell',
};
